import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationUIHelpers";

const OrganizationUIContext = createContext();

export function useOrganizationUIContext() {
  return useContext(OrganizationUIContext);
}

export const OrganizationUIConsumer = OrganizationUIContext.Consumer;

export function OrganizationUIProvider({ organizationUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganization = {
    name: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganization,
    newOrganizationButtonClick: organizationUIEvents.newOrganizationButtonClick,
    openEditOrganizationPage: organizationUIEvents.openEditOrganizationPage,
    openOrganizationFilePage: organizationUIEvents.openOrganizationFilePage
  };

  return (
    <OrganizationUIContext.Provider value={value}>
      {children}
    </OrganizationUIContext.Provider>
  );
}
